<template>
  <div
    class="bg-gray-20 br-sm text-gray-80 flex h-16 w-full items-center gap-2 rounded border-2 border-red-50 px-4 py-2 text-sm"
  >
    <alert-triangle-icon class="icon-m text-red-50" />
    {{ $t('modules.comment_editor.async_loader_error') }}
  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import { AlertTriangleIcon } from '@klausapp/ui-kit/icons'

defineComponent({ name: 'EditorError' })
</script>
